import React, {useEffect, useState} from 'react';
import 'styles/donations/DonationList.css';
import UniversalTypeFilter from 'components/universal/UniversalTypeFilter';
import DonationCard from 'components/donations/DonationCard';
import {getAdminAllLinks, getAdminUserDonations} from 'util/adminApi';

const AdminDonationList = ({userId}) => {
    const [donations, setDonations] = useState([]);
    const [filteredDonations, setFilteredDonations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedFilter, setSelectedFilter] = useState([]);

    useEffect(() => {
        setLoading(true);
        const fetchLinks = userId ? getAdminUserDonations : getAdminAllLinks;
        fetchLinks(userId)
            .then((response) => {
                const donationLinks = response
                    .map((link) => ({
                        id: link.id,
                        charityName: link.charityName,
                        link: link.link,
                        badgeId: link.badgeId,
                        createdOn: link.createdOn,
                        status: link.state,
                        rejectionReason: link.adminRejectionReason || null,
                        rawData: link,
                    }))
                    .sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn));

                setLoading(false);
                setDonations(donationLinks);
                setFilteredDonations(donationLinks);
            })
            .catch((error) => {
                console.error('Error fetching donation links:', error);
                setLoading(false);
            });
    }, [userId]);

    const handleFilterClick = (key) => {
        const updatedFilter = selectedFilter.includes(key)
            ? selectedFilter.filter((filterKey) => filterKey !== key)
            : [...selectedFilter, key];

        setSelectedFilter(updatedFilter);

        if (updatedFilter.length === 0) {
            setFilteredDonations(donations);
        } else {
            setFilteredDonations(
                donations.filter((donation) => updatedFilter.includes(donation.status.toUpperCase()))
            );
        }
    };

    const filterTypes = [['APPROVED', 'Approved'], ['REJECTED', 'Rejected'], ['PENDING', 'Pending']];

    return (
        <>
            <div className="donation-list-container">
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <UniversalTypeFilter
                        types={filterTypes}
                        highlightedKeys={selectedFilter}
                        itemClicked={handleFilterClick}
                    />
                </div>
                {loading ? (
                    <div>Loading...</div>
                ) : null}
                <ul className="donation-list">
                    {filteredDonations.map((donation) => (
                        <DonationCard key={donation.id} donation={donation} isAdmin={true}/>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default AdminDonationList;